import NOC from "../const/index";

/**
 * アカウント管理者か？
 */
export function isRoleAdmin(role :number) : boolean
{
  return role == NOC.SETTING.ROLE.VALUE.ADMIN;
}

/**
 * 労務管理者か？
 */
export function isRoleManager(role :number) : boolean
{
  return role == NOC.SETTING.ROLE.VALUE.MANAGER;
}

/**
 * アカウント管理者または労務管理者か？
 */
export function isRoleAdminOrManager(role :number) : boolean
{
  return isRoleAdmin(role) || isRoleManager(role);
}

/**
 * 一般ユーザーか？
 */
export function isRoleGeneral(role :number) : boolean
{
  return role == NOC.SETTING.ROLE.VALUE.GENERAL;
}

/**
 * 労務管理者または、一般ユーザーか？
 */
export function isRoleManagerOrGeneral(role :number) : boolean
{
  return isRoleManager(role) || isRoleGeneral(role);
}
